module.exports = __webpack_public_path__ + "src/routes/report/6.jpg?bd256ed6";


//////////////////
// WEBPACK FOOTER
// ./src/routes/report/6.jpg
// module id = 2863
// module chunks = 1